import type { FC } from 'react'
import type { MMSubmissionStatus } from '@/features/luxe-submissions/types'
import {
	mmParkingLotStatusAfterSecondReviewToLabelTKey,
	mmParkingLotStatusToBadgeStyle,
	mmParkingLotStatusToLabelTKey
} from '@/features/luxe-submissions/utils'
import { useTranslation } from '@/translations/i18n'

interface MMStatusBadgeProps {
	status: MMSubmissionStatus
	// The outcome of a second review reads differently from the first one
	hadSecondReview?: boolean | null
}

export const MMStatusBadge: FC<MMStatusBadgeProps> = ({
	status,
	hadSecondReview
}) => {
	const { t } = useTranslation()

	const afterSecondReviewLabel = hadSecondReview
		? mmParkingLotStatusAfterSecondReviewToLabelTKey[
				status as keyof typeof mmParkingLotStatusAfterSecondReviewToLabelTKey
			]
		: undefined

	return (
		<span
			className={`inline-flex rounded-full border px-2 py-0.5 font-medium text-xs ${mmParkingLotStatusToBadgeStyle[status]}`}
		>
			{t(afterSecondReviewLabel ?? mmParkingLotStatusToLabelTKey[status])}
		</span>
	)
}
